export default {
    'FlujoEtapa.EtapaActual': 'Current Stage',
    'FlujoEtapa.EtapaSiguiente': 'Stage Next Stage',
    'FlujoEtapa.Estado': 'State',
    'FlujoEtapa.Guardar': 'Save',
    'FlujoEtapa.Editar': 'Edit',
    'FlujoEtapa.EtapasIguales': 'The current stage and the next stage cannot be the same',
};
